'use client'

import FilterBadge from '@/app/components/FilterBadge';
import { AuctionFilterContext, Filter } from '@/lib/context/AuctionFilterContext';
import { Flex } from '@radix-ui/themes';
import React, { useContext, useEffect } from 'react';

const CLEAR_ALL_THRESHOLD = 3

const AuctionFilterGroup = () => {
  const auctionFilterContext = useContext(AuctionFilterContext);

  if (!auctionFilterContext?.filters.length) return null;

  return (
    <Flex className="space-x-2 gap-y-3 flex-wrap">
      {auctionFilterContext.filters.map((item: Filter, index: number) => (
        <FilterBadge
          key={index}
          text={item.label}
          onClick={() => {
            auctionFilterContext.deleteFilter(item);
          }}
        />
      ))}

      {auctionFilterContext.filters.length >= CLEAR_ALL_THRESHOLD && (
        <FilterBadge
          key="clear-all"
          text="Clear All"
          onClick={auctionFilterContext.clearFilters}
        />
      )}
    </Flex>
  );
};

export default AuctionFilterGroup;

